import {StoreRepositoryImpl} from '../repository/StoreRepositoryImpl';
import {StoreDeliveriesRepositoryImpl} from '../repository/StoreDeliveriesRepositoryImpl';
import {GetAllStoresUseCase} from '../useCases/GetAllStoresUseCase';
import {GetStoreDetailsUseCase} from '../useCases/GetStoreDetailsUseCase';
import {GetStoreStatisticsUseCase} from '../useCases/GetStoreStatisticsUseCase';
import {CreateStoreUseCase} from '../useCases/CreateStoreUseCase';
import {UpdateStoreUseCase} from '../useCases/UpdateStoreUseCase';
import {DeleteStoreUseCase} from '../useCases/DeleteStoreUseCase';
import {GetStoreDeliveriesTimelineUseCase} from '../useCases/GetStoreDeliveriesTimelineUseCase';
import {GetStoreDeliveryTransactionUseCase} from '../useCases/GetStoreDeliveryTransactionUseCase';

// Singleton pattern for store instances
class StoreFactory {
  private static instance: StoreFactory;
  private repository: StoreRepositoryImpl;
  private deliveriesRepository: StoreDeliveriesRepositoryImpl;
  private useCases: {
    getAllStores: GetAllStoresUseCase;
    getStoreDetails: GetStoreDetailsUseCase;
    getStatistics: GetStoreStatisticsUseCase;
    createStore: CreateStoreUseCase;
    updateStore: UpdateStoreUseCase;
    deleteStore: DeleteStoreUseCase;
    getStoreDeliveriesTimeline: GetStoreDeliveriesTimelineUseCase;
    getStoreDeliveryTransaction: GetStoreDeliveryTransactionUseCase;
  };

  private constructor () {
    this.repository = new StoreRepositoryImpl();
    this.deliveriesRepository = new StoreDeliveriesRepositoryImpl();
    this.useCases = {
      getAllStores: new GetAllStoresUseCase(this.repository),
      getStoreDetails: new GetStoreDetailsUseCase(this.repository),
      getStatistics: new GetStoreStatisticsUseCase(this.repository),
      createStore: new CreateStoreUseCase(this.repository),
      updateStore: new UpdateStoreUseCase(this.repository),
      deleteStore: new DeleteStoreUseCase(this.repository),
      getStoreDeliveriesTimeline: new GetStoreDeliveriesTimelineUseCase(this.deliveriesRepository),
      getStoreDeliveryTransaction: new GetStoreDeliveryTransactionUseCase(this.deliveriesRepository)
    };
  }

  public static getInstance (): StoreFactory {
    if (!StoreFactory.instance) {
      StoreFactory.instance = new StoreFactory();
    }
    return StoreFactory.instance;
  }

  public getRepository (): StoreRepositoryImpl {
    return this.repository;
  }

  public getUseCases () {
    return this.useCases;
  }
}

export const storeFactory = StoreFactory.getInstance();
